import AdminUserList from "./AdminUserList";

export default AdminUserList;
